import { Button_default } from "./chunk-GQ3JQOAN.js";
import { Link_default } from "./chunk-EFRJ3CR6.js";
import { Icon_default } from "./chunk-BTGG6N6L.js";
import { __objRest, __spreadValues } from "./chunk-ORMEWXMH.js";

// src/elements/FileInput/FileInput.tsx
import clsx from "clsx";
import React, { forwardRef, useCallback, useState } from "react";
var filterAcceptedFiles = (files, accept) => {
  const acceptedFiles = accept.split(",").map(type => type.trim().toLowerCase());
  return files.filter(file => {
    const extension = file.name.split(".").at(-1).toLowerCase();
    return acceptedFiles.includes(file.type.toLowerCase()) || acceptedFiles.includes(extension) || acceptedFiles.includes(".".concat(extension));
  });
};
var FileInput = forwardRef((_a, ref) => {
  var _b = _a,
    {
      children,
      id,
      disabled,
      selectLabel,
      dropLabel,
      icon,
      secondaryAction,
      onSelectFile,
      onDrop,
      onChange,
      multiple,
      accept,
      variant = "default",
      className,
      "aria-disabled": ariaDisabled
    } = _b,
    rest = __objRest(_b, ["children", "id", "disabled", "selectLabel", "dropLabel", "icon", "secondaryAction", "onSelectFile", "onDrop", "onChange", "multiple", "accept", "variant", "className", "aria-disabled"]);
  const [isDragOver, setIsDragOver] = useState(false);
  const isDisabled = disabled || ariaDisabled === "true";
  const getFilesFromFileList = useCallback(fileList => {
    const files = Array.from(fileList || []);
    const acceptedFiles = accept ? filterAcceptedFiles(files, accept) : files;
    return multiple ? acceptedFiles : acceptedFiles.slice(0, 1);
  }, [multiple, accept]);
  const handleSelect = useCallback(event => {
    if (isDisabled) return;
    const files = getFilesFromFileList(event.target.files);
    onSelectFile == null ? void 0 : onSelectFile(files);
    onChange(files);
  }, [getFilesFromFileList, onSelectFile, onChange, isDisabled]);
  const handleDragEnter = useCallback(event => {
    if (isDisabled) return;
    event.preventDefault();
    setIsDragOver(true);
  }, [isDisabled]);
  const handleDragLeave = useCallback(event => {
    if (isDisabled) return;
    event.preventDefault();
    setIsDragOver(false);
  }, [isDisabled]);
  const handleDragOver = useCallback(event => {
    if (isDisabled) return;
    event.preventDefault();
  }, [isDisabled]);
  const handleDrop = useCallback(event => {
    if (isDisabled) return;
    event.preventDefault();
    setIsDragOver(false);
    const files = getFilesFromFileList(event.dataTransfer.files);
    onDrop == null ? void 0 : onDrop(files);
    onChange(files);
  }, [getFilesFromFileList, onDrop, onChange, isDisabled]);
  return /* @__PURE__ */React.createElement("div", {
    className: clsx("pd-file-input", isDragOver && "pd-file-input--dragover", isDisabled && "pd-file-input--disabled", className)
  }, /* @__PURE__ */React.createElement("div", {
    onDragEnter: handleDragEnter,
    onDragLeave: handleDragLeave,
    onDragOver: handleDragOver,
    onDrop: handleDrop,
    className: clsx({
      "pd-file-input__input": variant === "default"
    })
  }, /* @__PURE__ */React.createElement("div", {
    className: "pd-nested-actions"
  }, variant === "button" && /* @__PURE__ */React.createElement("label", {
    htmlFor: id,
    className: "pd-file-input__button-label"
  }, /* @__PURE__ */React.createElement(Button_default, {
    as: "div",
    disabled: isDisabled,
    "aria-disabled": isDisabled,
    className: "pd-file-input__button",
    iconBefore: "upload"
  }, selectLabel)), /* @__PURE__ */React.createElement("input", __spreadValues({
    ref,
    id,
    type: "file",
    disabled,
    "aria-disabled": ariaDisabled,
    multiple,
    accept,
    onChange: handleSelect,
    className: "pd-sr-only"
  }, rest))), variant === "default" && /* @__PURE__ */React.createElement("div", {
    className: "pd-file-input__label"
  }, icon && /* @__PURE__ */React.createElement(Icon_default, {
    icon,
    size: "2xl",
    className: "pd-mb-3 pd-inline-flex"
  }), /* @__PURE__ */React.createElement("span", {
    className: "pd-block"
  }, dropLabel), /* @__PURE__ */React.createElement(Link_default, {
    as: "label",
    htmlFor: id,
    className: "pd-file-input__select-label"
  }, selectLabel)), secondaryAction && /* @__PURE__ */React.createElement("div", {
    className: "pd-file-input__secondary-action"
  }, secondaryAction)), children && /* @__PURE__ */React.createElement("ol", {
    className: "pd-file-input__files"
  }, children));
});
var FileInput_default = FileInput;
export { FileInput_default };